module.exports = __webpack_public_path__ + "img/tb-09@2x.0f20d88a.png";